const services = [
{
  id: 1,
  name: "MINIMUM SERVICE FEE",
  price: 180.0,
  category: "Electrical Tasks",
  desc: "Minimum service fee for small miscellaneous electrical jobs.",
  image: "/images/servicecall.jpeg",
},
  {
    id: 2,
    name: "TIE INTO AN EXISTING CIRCUIT (STANDARD)",
    price: 242.34,
    category: "Electrical Tasks",
    desc: "Connect to an existing electrical circuit using an existing electrical device box.",
  },
  {
    id: 3,
    name: "TIE INTO AN EXISTING CIRCUIT (COMPLEX)",
    price: 322.92,
    category: "Electrical Tasks",
    desc: "Connect to an existing circuit by breaking out and installing a new device box.",
  },
  {
    id: 4,
    name: "REPAIR AN ELECTRICAL DEVICE (STANDARD)",
    price: 52.16,
    category: "Electrical Tasks",
    desc: "Simple repair of an electrical device or wiring inside a device box.",
  },
  {
    id: 5,
    name: "REPAIR AN ELECTRICAL DEVICE (COMPLEX)",
    price: 86.43,
    category: "Electrical Tasks",
    desc: "Complex or time-consuming repair of an electrical device or wiring in a device box.",
  },
  {
    id: 6,
    name: "MISCELLANEOUS REPAIR (STANDARD)",
    price: 72.94,
    category: "Electrical Tasks",
    desc: "Repair miscellaneous electrical components.",
  },
  {
    id: 7,
    name: "MISCELLANEOUS REPAIR (COMPLEX)",
    price: 182.36,
    category: "Electrical Tasks",
    desc: "Repair miscellaneous electrical components in hard-to-reach or complex areas.",
  },
  {
    id: 8,
    name: "DELETE AN ELECTRICAL DEVICE",
    price: 200.59,
    category: "Electrical Tasks",
    desc: "Remove a device from an electrical circuit and safely disconnect the wiring and device.",
  },

  {
    id: 9,
    name: "15A1P BREAKER INSTALLATION (SIEMENS)",
    price: 126.25,
    category: "Breakers",
    desc: "Supply and install of a residential circuit breaker including wire terminations.",
  },
  {
    id: 10,
    name: "20A1P BREAKER INSTALLATION (SIEMENS)",
    price: 126.02,
    category: "Breakers",
    desc: "Supply and install of a residential circuit breaker including wire terminations.",
  },
  {
    id: 11,
    name: "30A1P BREAKER INSTALLATION (SIEMENS)",
    price: 156.43,
    category: "Breakers",
    desc: "Supply and install of a residential circuit breaker including wire terminations.",
  },
  {
    id: 12,
    name: "15A2P BREAKER INSTALLATION (SIEMENS)",
    price: 140.28,
    category: "Breakers",
    desc: "Supply and install of a residential circuit breaker including wire terminations.",
  },
  {
    id: 13,
    name: "20A2P BREAKER INSTALLATION (SIEMENS)",
    price: 180.7,
    category: "Breakers",
    desc: "Supply and install of a residential circuit breaker including wire terminations.",
  },
  {
    id: 14,
    name: "15A1P BREAKER (SQUARE D)",
    price: 135.59,
    category: "Breakers",
    desc: "Supply and install of a residential circuit breaker including wire terminations.",
  },
  {
    id: 15,
    name: "20A1P BREAKER (EATON)",
    price: 126.34,
    category: "Breakers",
    desc: "Supply and install of a residential circuit breaker including wire terminations.",
  },
  {
    id: 16,
    name: "15A1P BREAKER INSTALLATION (SCHNEIDER)",
    price: 154.17,
    category: "Breakers",
    desc: "Supply and install of a residential circuit breaker including wire terminations.",
  },

  {
    id: 17,
    name: "STANDARD SMOKE DETECTOR INSTALLATION",
    price: 110.19,
    category: "Devices",
    desc: "Supply and install battery backup smoke detector in place of an existing detector.",
  },
  {
    id: 18,
    name: "STANDARD SMOKE/CO DETECTOR INSTALLATION",
    price: 165.43,
    category: "Devices",
    desc: "Supply and install battery backup smoke and CO detector in place of an existing detector.",
  },
  {
    id: 19,
    name: "15A DECORA RECEPTACLE INSTALLATION",
    price: 71.1,
    category: "Devices",
    desc: "Replace worn receptacle with new tamper-resistant receptacle.",
  },
  {
    id: 20,
    name: "15A GFCI DECORA RECEPTACLE INSTALLATION",
    price: 127.66,
    category: "Devices",
    desc: "Upgrade to a GFCI receptacle for shock protection in high-risk locations.",
  },
  {
    id: 21,
    name: "15A USB DECORA RECEPTACLE INSTALLATION",
    price: 200.51,
    category: "Devices",
    desc: "Install fast-charging USB receptacle.",
  },
  {
    id: 22,
    name: "1 POLE DECORA SWITCH INSTALLATION",
    price: 71.87,
    category: "Devices",
    desc: "Install a sleek and modern Decora-style single-pole switch.",
  },
  {
    id: 23,
    name: "3 WAY DECORA SWITCH INSTALLATION",
    price: 76.21,
    category: "Devices",
    desc: "Install a Decora-style 3-way switch for multi-location control.",
  },
  {
    id: 24,
    name: "DIMMER SWITCH INSTALLATION",
    price: 134.46,
    category: "Devices",
    desc: "Install a dimmer switch for adjustable lighting control.",
  },

  {
    id: 25,
    name: "INSTALL STANDARD LIGHT FIXTURE (CUSTOMER PROVIDED)",
    price: 72.94,
    category: "Lighting",
    desc: "Install a standard pre-assembled light fixture.",
  },
  {
    id: 26,
    name: "INSTALL NON-STANDARD LIGHT FIXTURE (CUSTOMER PROVIDED)",
    price: 116.71,
    category: "Lighting",
    desc: "Install a non-standard light fixture requiring assembly or difficult access.",
  },
  {
    id: 27,
    name: "INSTALL CHANDELIER (CUSTOMER PROVIDED)",
    price: 1547.07,
    category: "Lighting",
    desc: "Professional installation and assembly of a chandelier.",
  },
  {
    id: 28,
    name: "INSTALL A CEILING FAN (CUSTOMER PROVIDED)",
    price: 364.71,
    category: "Lighting",
    desc: "Professional installation and assembly of a ceiling fan.",
  },
  {
    id: 29,
    name: "4' LED LIGHT UPGRADE",
    price: 203.72,
    category: "Lighting",
    desc: "Upgrade to an energy-efficient 4 foot LED light.",
  },
  {
    id: 30,
    name: "4X COMBO POT LIGHT INSTALL PACKAGE",
    price: 1855.9,
    category: "Lighting",
    desc: "Premium pot light installation package to brighten and modernize rooms.",
  },
  {
    id: 31,
    name: "ADD A POT LIGHT TO A LIGHTING PACKAGE",
    price: 280.28,
    category: "Lighting",
    desc: "Add another pot light to an existing pot light package.",
  },

  {
    id: 32,
    name: "BASIC 200 AMP ELECTRICAL PANEL UPGRADE PACKAGE",
    price: 5060.26,
    category: "Panels",
    desc: "200 amp electrical panel upgrade package with surge protection.",
  },
  {
    id: 33,
    name: "BASIC 100 AMP ELECTRICAL PANEL UPGRADE PACKAGE",
    price: 4465.61,
    category: "Panels",
    desc: "100 amp electrical panel upgrade package with surge protection.",
  },
  {
    id: 34,
    name: "SMART 100 AMP ELECTRICAL PANEL UPGRADE PACKAGE",
    price: 4824.61,
    category: "Panels",
    desc: "100 amp panel upgrade with smart home energy monitor.",
  },
  {
    id: 35,
    name: "SMART 200 AMP ELECTRICAL PANEL UPGRADE PACKAGE",
    price: 5419.26,
    category: "Panels",
    desc: "200 amp panel upgrade with smart home energy monitor.",
  },
  {
    id: 36,
    name: "PREMIUM 200 AMP ELECTRICAL PANEL UPGRADE PACKAGE",
    price: 6608.42,
    category: "Panels",
    desc: "200 amp premium panel upgrade with smart monitor and AFCI breakers.",
  },
  {
    id: 37,
    name: "SUB PANEL INSTALLATION",
    price: 551.34,
    category: "Panels",
    desc: "Add extra electrical capacity with a 125a 8/16 sub panel.",
  },

  {
    id: 38,
    name: "LEVEL 1 ELECTRICAL DIAGNOSTIC",
    price: 364.71,
    category: "Diagnostics",
    desc: "Quick assessment to identify common electrical issues.",
  },
  {
    id: 39,
    name: "LEVEL 2 ELECTRICAL DIAGNOSTIC",
    price: 729.42,
    category: "Diagnostics",
    desc: "Full circuit diagnostic for hidden or complex electrical problems.",
  },
  {
    id: 40,
    name: "LEVEL 3 ELECTRICAL DIAGNOSTIC",
    price: 1458.84,
    category: "Diagnostics",
    desc: "Complete evaluation of the entire electrical system.",
  },

  {
    id: 41,
    name: "INSTALL A CUSTOMER PROVIDED EV CHARGING STATION",
    price: 326.57,
    category: "EV Charging",
    desc: "Mounting, connection, and testing of customer-provided EV charging station.",
  },
  {
    id: 42,
    name: "DCC-12 ENERGY MANAGEMENT SYSTEM",
    price: 1887.49,
    category: "EV Charging",
    desc: "Energy management system allowing EV charging on a full panel.",
  },
  {
    id: 43,
    name: "WALLBOX 11.5KW 48A 25FT LEVEL 2 EV SMART CHARGER INSTALLATION",
    price: 1544.86,
    category: "EV Charging",
    desc: "Install and set up Wallbox Level 2 EV smart charger.",
  },
];

export default services;
